import React,{useCallback} from 'react'
import PropTypes from 'prop-types'
import {useSelector,useDispatch} from 'react-redux'
import {withRouter} from 'react-router-dom'

import {
  getCID,
  getCurrentStep,
  getDataFromURL
} from '../../../utilities/function/urlparams'

import PageSlider from '../../shared/pageslider'
import Breadcrumbs from '../../shared/breadcrumbs'
import SelectBillingCycle from '../../shared/steps/selectbillingcycle'
import { updateConfig } from '../../../app/action'
import ProductSidebar from '../../shared/sidebar/productsidebar'
import CloseButton from '../../shared/closebutton'
import SelectConfigOptions from '../../shared/steps/selectconfigoptions'

let EmailHosting = (props) => {
   const {
     configurations
   } = useSelector(state=>({
     configurations: state.app.configurations,
   }))
  const dispatch = useDispatch()
  const {location} = props
  const cid = getCID(getDataFromURL(location.search))
  const step = getCurrentStep(configurations,cid)
  const getBreadcrumbsData = () => {
    return [{
      label: 'Billing Cycle',
      itemStep: 0,
      configKey: 'billing_cycle_id'
    },{
      label: 'Mailboxes',
      itemStep: 1,
      configKey: 'config'
    }]
  }
  const setBillingCycleCallback = useCallback((billingCycleID) => {
    updateConfig(configurations, cid, {
      billing_cycle_id: billingCycleID,
      step: 1
    }, dispatch)
  }, [cid, configurations, dispatch])

  return (
    <div className={'of-email-hosting of-page'}>
      <div className={'of-page__wrapper'}>
        <PageSlider step={step} cid={cid}>
          <Breadcrumbs data={getBreadcrumbsData()} step={step} cid={cid} />
          <SelectBillingCycle showOn={0} callback={setBillingCycleCallback} cid={cid} />
          <SelectConfigOptions />
          <CloseButton />
        </PageSlider>
        <ProductSidebar />
      </div>
    </div>
  )
}

EmailHosting.propTypes = {
  location: PropTypes.object
}

EmailHosting = withRouter(EmailHosting)

export default EmailHosting